import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from 'modules/auth/context';
import { getPortalSubscription } from './api';
import { IS_IO } from 'lib/site';

export function usePortalSubscription() {
  const { state } = useAuthContext();
  return useQuery({
    queryKey: ['portal-subscription', state.user?.id],
    queryFn: ({ signal }) => getPortalSubscription(signal),
    // Learner plans are examing.uz only; on examing.io there is never a subscription.
    enabled: Boolean(state.user?.id) && !IS_IO,
  });
}
